import { render, staticRenderFns } from "./observe.vue?vue&type=template&id=54f21a19&scoped=true"
import script from "./observe.vue?vue&type=script&lang=js"
export * from "./observe.vue?vue&type=script&lang=js"
import style0 from "./observe.vue?vue&type=style&index=0&id=54f21a19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f21a19",
  null
  
)

export default component.exports